/* Rakhi Gift Hamper — live preview, character counter, emoji hint, and required-field
   enforcement. Enhancement only: the fields are native inputs inside {% form 'product' %},
   so values are captured even if this script never runs. Idempotent (the owning section can
   render on the page twice). */
(function () {
  'use strict';
  if (window.__rakhiInit) return;
  window.__rakhiInit = true;

  var EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}\u{2190}-\u{21FF}\u{2B00}-\u{2BFF}]/u;

  function init() {
    var root = document.querySelector('[data-rakhi-personalization]');
    if (!root) return;

    var from = root.querySelector('[data-rakhi="from"]');
    var to = root.querySelector('[data-rakhi="to"]');
    var note = root.querySelector('[data-rakhi="note"]');

    var previewTo = root.querySelector('[data-rakhi-preview="to"]');
    var previewNote = root.querySelector('[data-rakhi-preview="note"]');
    var previewFrom = root.querySelector('[data-rakhi-preview="from"]');
    var counter = root.querySelector('[data-rakhi-counter]');
    var emojiHint = root.querySelector('[data-rakhi-emoji-hint]');

    function syncPreview() {
      if (previewTo) previewTo.textContent = (to && to.value.trim()) ? to.value.trim() : '…';
      if (previewFrom) previewFrom.textContent = (from && from.value.trim()) ? from.value.trim() : '…';
      if (previewNote) {
        var n = note ? note.value : '';
        previewNote.textContent = n.trim() ? n : 'Your note will appear here as you type.';
      }
    }

    function syncCounter() {
      if (counter && note) counter.textContent = String(note.value.length);
      if (emojiHint && note) emojiHint.hidden = !EMOJI_RE.test(note.value);
    }

    [from, to].forEach(function (el) {
      if (el) el.addEventListener('input', function () { syncPreview(); clearError(el); });
    });
    if (note) note.addEventListener('input', function () { syncPreview(); syncCounter(); });
    syncPreview();
    syncCounter();

    // ---- Required-field enforcement ----
    var form = root.closest('form');
    function fieldWrap(el) { return el ? el.closest('.rakhi-field') : null; }
    function showError(el) {
      var wrap = fieldWrap(el);
      if (wrap) {
        wrap.classList.add('rakhi-field--invalid');
        var err = wrap.querySelector('[data-rakhi-error]');
        if (err) err.hidden = false;
      }
    }
    function clearError(el) {
      var wrap = fieldWrap(el);
      if (wrap) {
        wrap.classList.remove('rakhi-field--invalid');
        var err = wrap.querySelector('[data-rakhi-error]');
        if (err) err.hidden = true;
      }
    }
    function validate() {
      var firstInvalid = null;
      [from, to].forEach(function (el) {
        if (!el) return;
        var v = el.value.trim();
        if (v.length < 1 || v.length > 40) {
          showError(el);
          if (!firstInvalid) firstInvalid = el;
        } else {
          clearError(el);
        }
      });
      return firstInvalid;
    }

    if (form) {
      // Capture phase runs before Dawn's product-form.js bubble-phase submit handler,
      // so stopImmediatePropagation() prevents the fetch add-to-cart on invalid input.
      form.addEventListener('submit', function (e) {
        var bad = validate();
        if (bad) {
          e.preventDefault();
          e.stopImmediatePropagation();
          bad.focus();
        }
      }, true);
    }

    // Gold shimmer on the add-to-cart button (CSS gates the animation behind reduced-motion).
    if (form) {
      var submitBtn = form.querySelector('.product-form__submit');
      if (submitBtn) submitBtn.classList.add('rakhi-shimmer');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
